import { FC } from 'react';
import { getCookie } from 'typescript-cookie';
import { useTranslation } from 'react-i18next';

import { BulkImport } from '../../BulkImport';
import { ValidatedRow, BulkResult } from '../../BulkImport/types';
import { useWorkspaceStore } from '../../../store/workspace.store';
import { ESession } from '../../../enums/auth.enum';
import { bulkImportDrivers } from '../../../api/drivers.api';
import { DRIVER_COLUMNS, validateDrivers } from './validation';

interface BulkImportDriversProps {
    open: boolean;
    onCancel: () => void;
    refreshData: () => void;
}

const BulkImportDrivers: FC<BulkImportDriversProps> = ({
    open, onCancel, refreshData,
}) => {
    const { t } = useTranslation('drivers', { keyPrefix: 'DRIVERS' });
    const workspace = useWorkspaceStore((state) => state.data);

    const handleImport = async (validRows: ValidatedRow[]): Promise<BulkResult> => {
        const payload = validRows.map((row) => ({
            name: row.name,
            lastName: row.lastName,
            email: row.email,
            mobile: row.mobile,
            countryCode: row.countryCode,
            language: row.language.toLowerCase(),
            currency: row.currency,
            vehicleModelName: row.vehicleModelName,
            MCNumber: row.MCNumber,
            vehicleColor: row.vehicleColor,
            vehicleType: row.vehicleType,
            vehicleYear: Number(row.vehicleYear),
            deliveryProvider: workspace?.keyName,
        }));

        const token = getCookie(ESession.JWT) || '';
        const response = await bulkImportDrivers({ drivers: payload }, token);
        const data = response.data?.data || response.data;

        refreshData();

        return {
            total: data.total,
            successful: data.successful,
            failed: data.failed,
            errors: data.errors || [],
        };
    };

    return (
        <BulkImport
            open={open}
            onCancel={onCancel}
            columns={DRIVER_COLUMNS}
            validate={validateDrivers}
            onImport={handleImport}
            templateFileName="plantilla_conductores"
            t={t}
        />
    );
};

export { BulkImportDrivers };
